// src/plugins/cookieconsent.ts
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export function initCookieConsent() {
  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true
      },
      analytics: {}
    },

    language: {
      default: 'pl',
      translations: {
        pl: {
          consentModal: {
            title: 'Używamy plików cookies',
            description: 'Używamy plików cookies w celu poprawy jakości korzystania z serwisu.',
            acceptAllBtn: 'Akceptuj wszystkie',
            acceptNecessaryBtn: 'Odrzuć wszystkie',
            showPreferencesBtn: 'Zarządzaj preferencjami'
          },
          preferencesModal: {
            title: 'Ustawienia plików cookies',
            acceptAllBtn: 'Akceptuj wszystkie',
            acceptNecessaryBtn: 'Odrzuć wszystkie',
            savePreferencesBtn: 'Zapisz ustawienia',
            closeIconLabel: 'Zamknij',
            sections: [
              {
                title: 'Niezbędne pliki cookies',
                description: 'Wymagane do prawidłowego działania strony. Niektóre pliki cookie są niezbędne do zapewnienia podstawowych funkcji. Strona internetowa nie będzie działać poprawnie bez tych plików cookie. Są one domyślnie włączone i nie można ich wyłączyć.',
                linkedCategory: 'necessary'
              },
              {
                title: 'Analityczne pliki cookies',
                description: 'Pomagają nam ulepszać naszą stronę internetową poprzez zbieranie i raportowanie informacji na temat jej użytkowania.',
                linkedCategory: 'analytics'
              },
              {
                description: 'Więcej informacji znajdziesz w naszej <a href="https://mzd.bielsko.pl/rodo/" target="_blank" rel="noopener" class="cc-link">Polityce RODO</a>.'
              }
            ]
          }
        },
        en: {
            consentModal: {
                title: 'We use cookies',
                description: 'We use cookies to improve the quality of using the website.',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Reject all',
                showPreferencesBtn: 'Manage preferences'
            },
            preferencesModal: {
                title: 'Cookie settings',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Reject all',
                savePreferencesBtn: 'Save settings',
                closeIconLabel: 'Close',
                sections: [
                {
                    title: 'Necessary cookies',
                    description: 'Required for the proper functioning of the website. Some cookies are essential to provide basic functionalities. The website will not function properly without these cookies. They are enabled by default and cannot be disabled.',
                    linkedCategory: 'necessary'
                },
                {
                    title: 'Analytics cookies',
                    description: 'They help us improve our website by collecting and reporting information on how it is used.',
                    linkedCategory: 'analytics'
                },
                {
                    description: 'More information can be found in our <a href="https://mzd.bielsko.pl/rodo/" target="_blank" rel="noopener" class="cc-link">GDPR Policy</a>.'
                }
                ]
            }
        },

        de: {
            consentModal: {
                title: 'Wir verwenden Cookies',
                description: 'Wir verwenden Cookies, um die Qualität der Nutzung der Website zu verbessern.',
                acceptAllBtn: 'Alle akzeptieren',
                acceptNecessaryBtn: 'Alle ablehnen',
                showPreferencesBtn: 'Einstellungen verwalten'
            },
            preferencesModal: {
                title: 'Cookie-Einstellungen',
                acceptAllBtn: 'Alle akzeptieren',
                acceptNecessaryBtn: 'Alle ablehnen',
                savePreferencesBtn: 'Einstellungen speichern',
                closeIconLabel: 'Schließen',
                sections: [
                {
                    title: 'Notwendige Cookies',
                    description: 'Erforderlich für das ordnungsgemäße Funktionieren der Website. Einige Cookies sind notwendig, um grundlegende Funktionen bereitzustellen. Ohne diese Cookies funktioniert die Website nicht korrekt. Sie sind standardmäßig aktiviert und können nicht deaktiviert werden.',
                    linkedCategory: 'necessary'
                },
                {
                    title: 'Analyse-Cookies',
                    description: 'Sie helfen uns, unsere Website zu verbessern, indem Informationen über die Nutzung der Website gesammelt und ausgewertet werden.',
                    linkedCategory: 'analytics'
                },
                {
                    description: 'Weitere Informationen finden Sie in unserer <a href="https://mzd.bielsko.pl/rodo/" target="_blank" rel="noopener" class="cc-link">DSGVO-Richtlinie</a>.'
                }
                ]
            }
        },

        uk: {
            consentModal: {
                title: 'Ми використовуємо файли cookie',
                description: 'Ми використовуємо файли cookie для покращення якості користування сайтом.',
                acceptAllBtn: 'Прийняти всі',
                acceptNecessaryBtn: 'Відхилити всі',
                showPreferencesBtn: 'Керувати налаштуваннями'
            },
            preferencesModal: {
                title: 'Налаштування файлів cookie',
                acceptAllBtn: 'Прийняти всі',
                acceptNecessaryBtn: 'Відхилити всі',
                savePreferencesBtn: 'Зберегти налаштування',
                closeIconLabel: 'Закрити',
                sections: [
                    {
                        title: 'Необхідні файли cookie',
                        description: 'Потрібні для належної роботи вебсайту. Деякі файли cookie є необхідними для забезпечення базових функцій. Без них вебсайт не працюватиме належним чином. Вони ввімкнені за замовчуванням і не можуть бути вимкнені.',
                        linkedCategory: 'necessary'
                    },
                    {
                        title: 'Аналітичні файли cookie',
                        description: 'Допомагають нам покращувати вебсайт шляхом збору та аналізу інформації про його використання.',
                        linkedCategory: 'analytics'
                    },
                    {
                        description: 'Додаткову інформацію можна знайти в нашій <a href="https://mzd.bielsko.pl/rodo/" target="_blank" rel="noopener" class="cc-link">Політиці GDPR</a>.'
                    }
                ]
            }
        }
      }
    }
  });
}
